import { makeStyles } from '@material-ui/core/styles';

import { SIDE_COLUMN_PULL_UP } from 'core/components/layout-with-sidebar/layout-with-sidebar.styles';

const useStyles = makeStyles(() => ({
  bottomSpacing: {
    paddingBottom: 10
  },
  gridItem: {
    paddingBottom: 10,
    width: '100%'
  },
  // The side column is pulled up into the title's whitespace; the toggle sits below the title instead
  layoutToggle: {
    marginTop: SIDE_COLUMN_PULL_UP
  }
}));

export default useStyles;
